import https from "./https";
import store from "@/store";

const organization = store.state.general.organization;

const booking = {
  // 預約設定檔 booking_presets
  getBookingPresets(params) {
    return https.get(`admin/organizations/${organization.id}/booking-presets`, {
      params,
    });
  },
  createBookingPreset(params) {
    return https.post(
      `admin/organizations/${organization.id}/booking-presets`,
      params
    );
  },
  getBookingPreset(id, params = {}) {
    return https.get(
      `admin/organizations/${organization.id}/booking-presets/${id}`, {
        params
      });
  },
  updateBookingPreset(id, params) {
    return https.put(
      `admin/organizations/${organization.id}/booking-presets/${id}`,
      params
    );
  },
  updateBookingPresetReportConfig(id, params) {
    return https.put(
      `admin/organizations/${organization.id}/booking-presets/${id}/report-config`,
      params
    );
  },
  deleteBookingPreset(id) {
    return https.delete(
      `admin/organizations/${organization.id}/booking-presets/${id}`
    );
  },
  replicateBookingPreset(id) {
    return https.post(
      `admin/organizations/${organization.id}/booking-presets/${id}/replicate`
    );
  },
  // 預約記錄 bookings
  getBookings(presetId, params) {
    return https.get(
      `admin/organizations/${organization.id}/booking-presets/${presetId}/bookings`,
      { params }
    );
  },
  getCombinedBookings(presetId, params) {
    return https.get(
      `admin/organizations/${organization.id}/booking-presets/${presetId}/combined-bookings`,
      { params }
    );
  },
  getBookingOptions(presetId, params) {
    return https.get(`admin/organizations/${organization.id}/booking-presets/${presetId}/bookings/options`, { params });
  },
  createBooking(presetId, params) {
    return https.post(
      `admin/organizations/${organization.id}/booking-presets/${presetId}/bookings`,
      params
    );
  },
  getBooking(presetId, bookingId) {
    return https.get(
      `admin/organizations/${organization.id}/booking-presets/${presetId}/bookings/${bookingId}`
    );
  },
  updateBooking(presetId, bookingId, params) {
    return https.put(
      `admin/organizations/${organization.id}/booking-presets/${presetId}/bookings/${bookingId}`,
      params
    );
  },
  deleteBooking(presetId, bookingId) {
    return https.delete(
      `admin/organizations/${organization.id}/booking-presets/${presetId}/bookings/${bookingId}`
    );
  },
  updateBookingStatus(presetId, bookingId, params) {
    return https.post(`admin/organizations/${organization.id}/booking-presets/${presetId}/bookings/${bookingId}/status`, params);
  },

  setupBookingPresetBranch(presetId, branchId, params) {
    return https.put(`admin/organizations/${organization.id}/booking-presets/${presetId}/branch/${branchId}`, params);
  },
  setupBookingPresetBranchNotification(presetId, branchId, params) {
    return https.put(`admin/organizations/${organization.id}/booking-presets/${presetId}/branch/${branchId}/notification`, params);
  },
  deleteBookingPresetBranch(presetId, branchId) {
    return https.delete(`admin/organizations/${organization.id}/booking-presets/${presetId}/branch/${branchId}`);
  },
  // 匯出 bookings
  exportBookings(presetId, params) {
    return https.get(
      `admin/organizations/${organization.id}/booking-presets/${presetId}/bookings/export`,
      { params }
    );
  },

  // 預約班表 shifts
  getBookingShifts(presetId, params) {
    return https.get(
      `admin/organizations/${organization.id}/booking-presets/${presetId}/shifts`,
      { params }
    );
  },
  createBookingShift(presetId, params) {
    return https.post(
      `admin/organizations/${organization.id}/booking-presets/${presetId}/shifts`,
      params
    );
  },
  getBookingShift(shiftId) {
    return https.get(
      `admin/organizations/${organization.id}/booking-presets/shifts/${shiftId}`
    );
  },
  updateBookingShift(shiftId, params) {
    return https.put(
      `admin/organizations/${organization.id}/booking-presets/shifts/${shiftId}`,
      params
    );
  },
  deleteBookingShift(shiftId) {
    return https.delete(
      `admin/organizations/${organization.id}/booking-presets/shifts/${shiftId}`
    );
  },
  importBookingPresetDate(presetId, formData) {
    return https.post(
      `/admin/organizations/${organization.id}/booking-presets/${presetId}/import/date`,
      formData
    );
  },
  exportBookingPresetBranchDate(presetId) {
    return https.post(
      `/admin/organizations/${organization.id}/booking-presets/${presetId}/export/date`
    );
  },
  getBookingsWithFormatData(presetId, params) {
    return https.get(
      `admin/organizations/${organization.id}/booking-presets/${presetId}/bookings/format-data`,
      { params }
    );
  },

  // Periodic Bookings
  getPeriodicBookings(presetId, params) {
    return https.get(
      `admin/organizations/${organization.id}/booking-presets/${presetId}/periodic-bookings`,
      { params }
    );
  },
  createPeriodicBooking(presetId, params) {
    return https.post(
      `admin/organizations/${organization.id}/booking-presets/${presetId}/periodic-bookings`,
      params
    );
  },
  getPeriodicBooking(periodicBookingId) {
    return https.get(
      `admin/organizations/${organization.id}/periodic-bookings/${periodicBookingId}`
    );
  },
  updatePeriodicBooking(periodicBookingId, params) {
    return https.put(
      `admin/organizations/${organization.id}/periodic-bookings/${periodicBookingId}`,
      params
    );
  },
  deletePeriodicBooking(periodicBookingId, params) {
    return https.delete(
      `admin/organizations/${organization.id}/periodic-bookings/${periodicBookingId}`,
      { data: params }
    );
  }
}

export default booking;
